/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum FormFieldNames {
    PlatformFilter = 'parameters.platformFilter[0]',
    RetentionTypeFilter = 'parameters.retentionTypeFilter[0]',
    ProcessedPercentage = 'parameters.processedPercentage',
}
